export default{
  state:{
    redactInstrument:{},//需要编辑的仪器
    selectWarehouse:'',//选中仓库
    yqtype:1,//选中仪器列表还是仪器组还是固定 1，2，3
    updateInstr:false,//用了判断是否数据是否更新成功
  },
  mutations:{
    SET_REDACT_INSTRU(state,Instrument){
      state.redactInstrument=Object.assign({},Instrument)
      // state.redactInstrument=Instrument
    },
    setWarehouse(state,selectWarehouse){
      state.selectWarehouse=selectWarehouse
    },
    setType(state,yqtype){
      state.yqtype=yqtype
    },
    SET_UPDATE_INSTR(state,updateInstr){
      state.updateInstr=updateInstr
    }
  },
  actions:{
    setInstrument({commit},data){
      commit('SET_REDACT_INSTRU',data)
    },
    setUpdateInstr({commit},data){
      commit('SET_UPDATE_INSTR',data)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/depot.js